import React from "react";

type FormFieldErrorType = "info" | "error";

export interface FormFieldErrorProps {
  errorMessage?: string;
  errorType?: string;
  isOpen?: boolean;
  fieldName?: string;
}

const getErrorType = (
  errorType: FormFieldErrorType,
  returnFullClassName = false,
): string => {
  const classNames: Record<FormFieldErrorType, string> = {
    info: "seem-icon-info",
    error: "seem-icon-error",
  };

  const baseTypes: Record<FormFieldErrorType, string> = {
    info: "info",
    error: "error",
  };

  if (returnFullClassName) {
    return classNames[errorType] || "";
  } else {
    return baseTypes[errorType] || "";
  }
};

const FormFieldError: React.FC<FormFieldErrorProps> = ({
  errorMessage = "",
  errorType = "error",
  fieldName = "",
}) => {
  const validErrorType: FormFieldErrorType = ["info", "error"].includes(
    errorType,
  )
    ? (errorType as FormFieldErrorType)
    : "error";

  return (
    <span className="input-error-message" data-testid={`${fieldName}-error`}>
      <i className={`seem-icon ${getErrorType(validErrorType, true)}`} />
      {errorMessage}
    </span>
  );
};

export default FormFieldError;
